
// Do not type this object, we'll loose auto-complete of all the properties.
export const SPEC_ID = {

    DK: {
        BLOOD: "c0ea1da3-1791-46f4-b82e-a9ceb6f34c81",
        FROST: "af0c2b46-1fe8-4426-a21f-1e07647a3516",
        UNHOLY: "fd573a39-1a54-4f17-8fbb-d21062de92f4",
    },

    DH: {
        VENG: "362587e1-8011-433a-bd68-984d4de9f8b7",
        HAVOC: "53189673-6292-4788-afa6-50892a18278d",
    },

    DRUID: {
        RESTO: "a0361ea0-7cc1-4a5a-a4ca-53764d3d799f",
        GUARD: "a4b9b8c7-b03f-418d-b025-668bc4693368",
        FERAL: "14fd1ebc-a950-43ca-a22e-26c7fd2808a8",
    },

    HUNTER: {
        BM: "2a602894-f863-4a89-b284-51ce7729f9cd",
        MM: "1e17ff7d-0166-465e-9010-a88c111f4528",
        SV: "cf3db3e6-0295-4954-99b6-de306f87ffee",
    },

    MAGE: {
        FROST: "785ebaf9-bd8f-4e8d-9260-65fd989fbf4f",
        FIRE: "f253f383-7a95-493a-9630-8db4c4d1baf6",
        ARCANE: "5adee364-7797-462f-955e-fca39301f060",
    },

    MONK: {
        BRM: "68352647-3c31-4430-ba2e-ec25c4e9d205",
        MW: "c993628a-c7c8-41f8-bf57-b592b62791e3",
        WW: "1e2ad351-c054-41eb-b13c-237f83da12db",
    },

    PALADIN: {
        PROT: "4c43b675-af0d-4b10-8549-35c07ba86ddf",
        RET: "82b7d660-f75e-4a12-869b-bb768e7942a7",
        HOLY: "62d5d1d8-c9ae-44a0-b070-409438ca88f0",
    },

    PRIEST: {
        DISC: "9fc69b2f-9069-42fd-a585-4262ae6aab04",
        HOLY: "7bb17135-395c-4ad8-ade1-77587084c3cf",
        SHADOW: "96252472-4154-4240-9c17-50b2e7f89bf9",
    },

    ROGUE: {
        OUT: "30e6fa68-455d-4eef-81de-4d18bed62b4d",
        SIN: "9d6ed377-ee84-4500-a6e3-458bacfd4714",
        SUB: "0bd34231-5ed4-40f9-99b7-de782ed5c8df",
    },

    SHAMAN: {
        RESTO: "65c245a3-fda3-4a01-8bba-f531eabe6273",
        ELE: "3555aec9-d248-4467-b5cd-0a0a439617bb",
        ENH: "d6bc6516-ee63-4cb0-b71e-d5b7cb06e15b",
    },

    WARLOCK: {
        DEST: "40ca382a-bfce-48b2-a7dd-e24eae9d9a6a",
        AFFLI: "5d58b02c-fb2f-4f74-976a-8d21c71fc1ac",
        DEMO: "2eabf059-fb6b-4301-997b-1764fe3b93f3",
    },

    WARRIOR: {
        PROT: "b227b2d3-8844-48d5-aa14-8a17e0bd86f6",
        ARMS: "4343c99d-7ac0-407d-8826-2f189b111c68",
        FURY: "c86e9f69-fb08-4dc6-b7ad-0167a322f127",
    }

}
